/**
 * This types not directly map Airflow enums.
 * We can't use enums directly as const,
 * because of isolatedModules=true in ts config
 */

// Airflow.FareFamily.Description.State
export const FF_SERVICE_STATE = {
  NOT_OFFER: 'NOT OFFER',
  INCLUDED: 'INCLUDE',
  CHARGEABLE: 'CHARGABLE',

  // Not included in platform type, we use it if we can't properly decide if service included or not
  UNKNOWN: 'UNKNOWN',
};

// Airflow.FareFamily.Description.Type
export const FF_SERVICE_TYPE = {
  HAND_LUGGAGE: 'hand_luggage',
  BAGGAGE: 'baggage',
  EXCHANGE: 'exchange',
  REFUND: 'refund',
  DISCOUNT: 'discount',
};

// Service type we display in UI
export const FF_SERVICE_MAIN_TYPE_LIST = [
  FF_SERVICE_TYPE.HAND_LUGGAGE,
  FF_SERVICE_TYPE.BAGGAGE,
  FF_SERVICE_TYPE.EXCHANGE,
  FF_SERVICE_TYPE.REFUND,
];
